import {
  fontSize16,
  gridGutterHalf,
  gridGutter1q1dot5
} from "@maxmilhas/hangar-components-atomic/public/styles/components/quarks/layout";

import theme from '../../../../js/shared/new-theme';

export const styleItemCardInfoRanking = `
  .title {
    font-size: ${fontSize16};
    font-weight: bold;

    &--ranking {
      font-weight: bold;
      margin-bottom: ${gridGutterHalf}px;
      padding-top: ${gridGutterHalf}px;
    }
  }
  .info {
    margin: ${gridGutter1q1dot5}px 0  25vh 0;
    @media (max-width: 767px) {
      margin: ${gridGutter1q1dot5}px 0;
    }
  }
`;

export const defaultStyle = `
  .title {
    color: ${theme.palette.gray[800].value};
    font-size: ${fontSize16};
    font-weight: bold;
  }
`;
